export default {
    getSearchConfigDataTableOptions: state => state.dataTableOptions,
    getSearchConfigRowActions: state => state.rowActions,
    getSearchConfigHeaderFields: state => state.headerFields
}
